import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import classNames from "classnames";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../Actions/AxiosInstance";
import { ChangeLanguage } from "../../../Actions/LanguageAction";
import {
  ValidateAction,
  ValidateReqField,
  ValidateReqFields,
} from "../../../Utils/Validation";
import "../../SignUp/LeadSignup/LeadSignup.css";
import "../Login.css";
import "../SubscriptionForgotPassword/index.css";
import SubscriptionUpdatePasswordSuccess from "./SubscriptionUpdatePasswordSuccess";
import { getFormattedImageLink, getFormattedLogoLink } from "../../../Utils";

const styles = (theme) => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    height: 56,
  },
  leadloginbutton: {
    width: 200,
    height: 56,
  },
  padding30: {
    padding: 30,
  },
  root: {
    flexGrow: 1,
  },
});

class UpdateSubscriptionPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      subdomain: window.location.hostname,
      amount: "",
      password: "",
      flag: 1,
      showPassword: false,
      checkedA: true,
      checkedB: true,
      reqFields: {
        password: "",
      },
      fields: {
        password: "",
        isSubscription: true,
      },
      errors: {},
      helperText: {},
      submitButton: true,
      SubscriptionDetails: {},
    };
  }

  componentWillMount() {
    // let subdomain = this.state.subdomain.split('.')
    //   subdomain = subdomain[0]
    //   this.props.VerifySubscription(subdomain)

    this.props.ChangeLanguage("updatesubscriptionpassword");
  }

  componentWillReceiveProps(props) {
    if (props.SubscriptionInfo.IsError) {
      this.props.enqueueSnackbar(props.SubscriptionInfo.ErrorMessage, {
        variant: "error",
      });
      this.props.histry.push("/**");
      // this.props.updateAuthentication('LOGIN_PENDING', null)
    } else if (props.SubscriptionInfo.IsFulfilled) {
      const SubscriptionDetails = props.SubscriptionInfo.SubscriptionData;
      const { fields } = this.state;
      fields.accountid = SubscriptionDetails.accountid;
      this.setState({ SubscriptionDetails, fields });
    }

    instance
      // .get(`account/validateresetlink/${this.props.match.params.auditid}`)
      .get(`account/validateresetlink/${this.props.match.params.auditid}`)
      .then((result) => {
        if (result.data.result["0"].isvalid) {
          this.setState({ isvalid: true });
        } else {
          this.setState({ isvalid: false });
          this.props.enqueueSnackbar(
            "Your link is expired.Please try it again",
            {
              variant: "error",
            },
          );
          setTimeout(() => {
            localStorage.clear();
            const URL = `${window.location.origin}/login`;
            window.open(URL, "_self");
          }, 250);
        }
      })
      .catch((error) => {
        setTimeout(() => {
          localStorage.clear();
          const URL = `${window.location.origin}/login`;
          window.open(URL, "_self");
        }, 250);
        this.props.enqueueSnackbar(error.response.data.error.message, {
          variant: "error",
        });
      });
  }

  handleClickShowPassword = () => {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  };

  handleCheckboxChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  ForgotPasswordAction() {
    if (!this.Validate()) {
      // this.setState({
      //   CommonError: (
      //     <FormattedMessage
      //       id="LbPleasefill"
      //       defaultMessage="Please fill all the required fields"
      //     />
      //   )
      // });
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });

      return;
    }

    this.setState({ CommonError: "" });
    instance
      .post(
        "account/updatepassword",
        Object.assign(this.props.match.params, this.state.fields),
      )
      .then(() => {
        this.setState({ flag: 2 });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  SetHelperTextFlag(field, e) {
    const { helperText } = this.state;
    helperText[field] = true;
    this.setState({ helperText });
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    fields[field] = e.target.value ? e.target.value : "";
    this.setState({ fields });
    ValidateAction(this.state, field, type);
  }

  ValidateField(reqField, type, e) {
    const { reqFields } = this.state;
    reqFields[reqField] = e.target.value ? e.target.value : "";
    this.setState({ reqFields });
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  Validate() {
    let formIsValid = true;

    if (!ValidateReqFields(this.state)) {
      formIsValid = false;
    }
    return formIsValid;
  }

  render() {
    const { classes } = this.props;
    const setflag = this.state.flag;
    let model;
    // if (setflag === 1 && isvalid) {
    if (setflag === 1) {
      model = (
        <div
          style={{
            height: "88vh",
            display: "table",
            width: "60%",
            margin: "0 auto",
          }}
        >
          <form className="lead-signup-form1 roleselect">
            <div className="sucesslogo">
              <div className="hello-welcome">
                <FormattedMessage
                  id="LbHello"
                  defaultMessage="Hello, welcome!"
                />
              </div>
              <div className="login-into-your-sumhr">
                <FormattedMessage
                  id="LbUpadte"
                  defaultMessage="Update your password"
                />
              </div>
              <div className="margin-bottom-20">
                <p className="form-input-label">
                  <FormattedMessage id="LbPassword" defaultMessage="Password" />
                </p>
                <TextField
                  id="password"
                  className={classNames(classes.dense, "width100")}
                  margin="dense"
                  variant="outlined"
                  type={this.state.showPassword ? "text" : "password"}
                  // label={
                  //   <FormattedMessage
                  //     id="Lbnewpassword"
                  //     defaultMessage="new password"
                  //   />
                  // }
                  onFocus={this.SetHelperTextFlag.bind(this, "password")}
                  onChange={this.OnFieldChange.bind(
                    this,
                    "password",
                    "password",
                  )}
                  onBlur={this.ValidateField.bind(this, "password", "password")}
                  error={!!this.state.errors.password}
                  InputProps={{
                    maxLength: 25,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="ShowPassword"
                          aria-label="Toggle password visibility"
                          onClick={this.handleClickShowPassword}
                        >
                          {this.state.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                {!!this.state.errors.password &&
                !this.state.helperText.password ? (
                  <span className="caption-error">
                    <FormattedMessage
                      id="Ernewpassword"
                      defaultMessage="Minimum 8 characters, please 🙏"
                    />{" "}
                  </span>
                ) : (
                  ""
                )}
                {this.state.helperText.password ? (
                  <span className="caption-helptest">
                    <FormattedMessage
                      id="Htnewpassword"
                      defaultMessage="Your corporate email id gets you exclusive perks like priority
                    support, free access to webiners and zero spam"
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div className="forget-pass-button">
                <Button
                  variant="contained"
                  color="primary"
                  className="leadloginbutton"
                  onClick={this.ForgotPasswordAction.bind(this)}
                >
                  <FormattedMessage id="BtSubmit" defaultMessage="SUBMIT" />
                </Button>
              </div>
              <span className="caption-error">{this.state.CommonError}</span>
            </div>
          </form>
        </div>
      );
      // } else if (setflag === 2 && isvalid) {
    } else if (setflag === 2) {
      model = (
        <div
          style={{
            height: "88vh",
            display: "table",
            width: "60%",
            margin: "0 auto",
          }}
        >
          <SubscriptionUpdatePasswordSuccess />
        </div>
      );
      // } else {
    } else {
      model = (
        <div>
          <span className="caption-error">{this.state.CommonError}</span>
        </div>
      );
      // }
    }
    const language = this.props.Language.updatesubscriptionpassword;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="loginbg" style={{ width: "100%" }}>
          <div className={classes.root}>
            <Grid container>
              <Grid item xs={12} md={6} sm={12} className="leadloginformdiv">
                <div align="center" className="logo">
                  <img
                    src={getFormattedLogoLink(
                      this.state.SubscriptionDetails.logo,
                    )}
                    height="60"
                    alt="logo"
                  />
                </div>
                {model}
              </Grid>
              <Grid item xs={12} md={6} sm={12}>
                <div className="win-height position-rel">
                  {this.state.SubscriptionDetails.bgimage ? (
                    <div>
                      <div
                        className="applogin-bgimg1"
                        style={{ height: "100vh" }}
                      >
                        <img
                          src={getFormattedImageLink(
                            this.state.SubscriptionDetails.bgimage,
                          )}
                          width={"100%"}
                          height={"100%"}
                          style={{ objectFit: "cover" }}
                        ></img>
                      </div>
                      <div className="applogin-cont">
                        <div className="HRMSimplified">
                          {this.state.SubscriptionDetails.headertext
                            ? this.state.SubscriptionDetails.headertext
                            : "HRMSimplified"}
                        </div>
                        <div>
                          <React.Fragment>
                            {this.state.SubscriptionDetails.subheadertext ? (
                              <p className="simplifided-slogan padding-top-30">
                                {this.state.SubscriptionDetails.subheadertext}
                              </p>
                            ) : (
                              <p className="simplifided-slogan padding-top-30">
                                Save your money for Growth, Use your time for
                                Relationships.
                              </p>
                            )}
                          </React.Fragment>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="HRMSimplified-div">
                      <div className="applogin-cont">
                        <div className="HRMSimplified">
                          {this.state.SubscriptionDetails.headertext
                            ? this.state.SubscriptionDetails.headertext
                            : "HRMSimplified"}
                        </div>
                        <div className="simplifided-slogan">
                          {this.state.SubscriptionDetails.subheadertext ? (
                            this.state.SubscriptionDetails.subheadertext
                          ) : (
                            <p className="simplifided-slogan padding-top-30">
                              Save your money for Growth, <br /> Use your time
                              for Relationships.
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

UpdateSubscriptionPassword.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(UpdateSubscriptionPassword)));
